package ui.user

import androidx.compose.runtime.*
import androidx.compose.ui.text.input.TextFieldValue
import common.frontend.api.Io
import common.frontend.api.canUserAdd
import io.Repository
import kotlinx.coroutines.launch
import tk.mallumo.compose.navigation.navTo_UserUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.findRoot
import tools.printStackTraceInDebug
import ui.snackBarStateGlobal
import ui.user.detail.UserArgs

@VM
class UserListingVM : NavigationViewModel() {

    private lateinit var scopeUi: UserListingScope

    var state by mutableDataState<UserListingScope.Wrapper>()
        private set

    var canAdd by mutableStateOf(false)
        private set


    val searchFiled = mutableStateOf(TextFieldValue(""))

    sealed interface Action {
        class New(val item: Io.ListingUser.Item) : Action
        companion object {

            @Composable
            fun rememberAction(vm: UserListingVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            is New -> vm.newUser(act.item)
                        }
                    }
                }
            }
        }
    }

    private fun newUser(item: Io.ListingUser.Item) {
        scope.launch {
            runCatching {
                val new = Repository.api.user.add(scopeUi.args.companyId, item)
                state.entry?.add(0, new)
                scopeUi.nav.findRoot().navTo_UserUI(UserArgs(userId = new.id))
            }.onFailure {
                it.printStackTraceInDebug()
                snackBarStateGlobal.showSnackbar(
                    it.message!!,
                    withDismissAction = true
                )
            }
        }
    }


    fun init(scopeUi: UserListingScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }
        scope.launch {
            runCatching {
                canAdd = scopeUi.login.canUserAdd(scopeUi.args.companyId)

                val data = if (scopeUi.args.showAll) Repository.api.user.listingAll()
                else Repository.api.user.listing(scopeUi.args.companyId)

                state = DataState.Result(UserListingScope.Wrapper(data))
            }.onFailure {
                it.printStackTraceInDebug()
                state = DataState.Error(it.message!!, throwable = it)
            }
        }
    }

    override fun onRelease() {
        state.entry?.release()
        state = DataState.Idle()
    }

}


